import * as React from 'react';

import { useIsomorphicLayoutEffect } from 'shared/components/popups/BasePopup/hooks';

/**
 * Вызывает `onNotify` в следующем animation frame после commit layout и при каждом
 * изменении размера элемента `ref` (ResizeObserver).
 */
const useResizeLayoutNotify = (
  ref: React.RefObject<HTMLElement | null>,
  onNotify?: () => void
): void => {
  useIsomorphicLayoutEffect(() => {
    if (!onNotify) {
      return;
    }
    const el = ref.current;
    if (!el) {
      return;
    }
    let raf = 0;
    let cancelled = false;
    const tick = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        if (!cancelled) {
          onNotify();
        }
      });
    };
    tick();
    const observer = new ResizeObserver(() => tick());
    observer.observe(el);
    return () => {
      cancelled = true;
      cancelAnimationFrame(raf);
      observer.disconnect();
    };
  }, [onNotify]);
};

export default useResizeLayoutNotify;
